import { render, staticRenderFns } from "./AgentWithdrawInfoAdd.vue?vue&type=template&id=157d8830&scoped=true&"
import script from "./AgentWithdrawInfoAdd.vue?vue&type=script&lang=js&"
export * from "./AgentWithdrawInfoAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157d8830",
  null
  
)

export default component.exports